import routes from "./applicationRoutes";
import applicationStore from "./applicationStore";
import links from "./links";
import store from "@/store";
import router from "@/router";

export default {
  install() {
    router.addRoute("Dashboard", routes);

    store.registerModule("Application", applicationStore);
    store.commit("Dashboard/SET_LINKS", links);
  },
};
